/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { httpService } from "../../../../services";
import { HTTP_METHOD } from "@nf/constants";
import { PlatformType } from "../../../../enums";
import { IAnonymousSessionModel, ISessionModel } from "../models";

export class SessionService {
  get url(): string {
    return `/v2/auth`;
  }

  public get = (): Promise<ISessionModel> =>
    httpService.request<ISessionModel>({
      method: HTTP_METHOD.GET,
      url: `${this.url}/session`,
    });

  public getAnonymousSession = async (
    deviceId: string,
    deviceType: PlatformType.Web | PlatformType.SmartTV = PlatformType.Web
  ): Promise<IAnonymousSessionModel> => {
    return httpService.request<IAnonymousSessionModel>({
      method: HTTP_METHOD.POST,
      url: `${this.url}/anonymous`,
      data: {
        device: {
          type: deviceType,
        },
        deviceId,
      },
    });
  };
}
